module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "toggle-switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "change": _vm.toggle
    }
  }), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "toggle-switch-background"
  }, [_c('span', {
    staticClass: "toggle-switch-handle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a267634"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/togglebutton/togglebutton.vue.html
// module id = mLWO
// module chunks = 2